import { Link } from 'react-router-dom';

export function HomePage() {
  return <div className="landing page-width">
    <section className="hero">
      <div>
        <p className="eyebrow">Local-first MapleStory market tracking</p>
        <h1>Build a private, offline Owl price library.</h1>
        <p className="hero-copy">Fredrick transcribes Owl of Minerva screenshots in the browser, keeps machine-produced observations immutable, and prepares them for deterministic local analysis and occasional validated synchronization.</p>
        <div className="hero-actions"><Link className="button primary" to="/import">Import screenshots</Link><Link className="button secondary" to="/library">Open library</Link></div>
      </div>
      <div className="hero-card" aria-label="Fredrick repository model">
        <div className="hero-card-head"><span>Repository v1</span><small>local first</small></div>
        <div className="repository-flow"><strong>Capture</strong><i>→</i><strong>Revision</strong><i>→</i><strong>Search</strong><i>→</i><strong>Summary</strong></div>
        <p>Authoritative page data stays immutable. Grouping and statistics are rebuildable views.</p>
      </div>
    </section>
    <section className="feature-grid">
      <article><span className="feature-number">01</span><h2>Canonical identity</h2><p>Full-source RGB pixels identify accidental reimports; the private Owl crop has a separate evidence identity.</p></article>
      <article><span className="feature-number">02</span><h2>Offline repository</h2><p>Imports, browsing, grouping, and price history will work entirely from IndexedDB without a network connection.</p></article>
      <article><span className="feature-number">03</span><h2>Pull-heavy sync</h2><p>Remote metadata is pulled into the local repository; pending local revisions are buffered and pushed in aggregated batches.</p></article>
    </section>
  </div>;
}
